import $ from 'jquery';
import hamburger from '../libs/hamburger';
import aos from '../libs/aos';
import slick from '../libs/slick';
import packagePreview from '../libs/package';
import aree from '../libs/aree';
import multipleSlidersInit from '../libs/multipleSlidersInit';
import datepicker from '../libs/datepicker';
import bookingEngine from '../libs/bookingEngine';

export default
    {
        init() {
            aos();
            multipleSlidersInit();
        },

        finalize() {
            hamburger();
            slick('.slider');
            packagePreview();
            aree();
            datepicker();
            bookingEngine()
        },
    }



// WEBPACK FOOTER //
// ./scripts/routes/common.js